import React from "react";
import { NavLink } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import { getLotteryPrizeAction } from "./lottery-utils";

function LotteryPrizeModal({ prize, onClose, onContinueDraw }) {
  if (!prize) return null;

  const isThanks = prize.type === "thanks";
  const prizeAction = getLotteryPrizeAction(prize);

  return (
    <div className="lottery-prize-modal-mask">
      <div className="lottery-prize-modal">
        <button
          type="button"
          className="lottery-prize-modal-close"
          onClick={onClose}
        >
          <CloseOutlined />
        </button>
        <div className="lottery-prize-modal-decor lottery-prize-modal-decor-a">
          +
        </div>
        <div className="lottery-prize-modal-decor lottery-prize-modal-decor-b">
          ·
        </div>
        <div className="lottery-prize-modal-decor lottery-prize-modal-decor-c">
          券
        </div>
        <div className="lottery-prize-modal-title">
          {isThanks ? "谢谢参与" : "恭喜中奖！"}
        </div>
        <div className="lottery-prize-modal-subtitle">
          {isThanks ? "再接再厉，大奖还在等你" : "您获得以下奖品"}
        </div>
        <div className="lottery-prize-card">
          <div className="lottery-prize-card-icon">{prize.icon}</div>
          <div className="lottery-prize-card-content">
            <div className="lottery-prize-card-name">{prize.label}</div>
            <div className="lottery-prize-card-desc">{prize.description}</div>
            <div className="lottery-prize-card-expire">{prize.expires}</div>
          </div>
        </div>
        {isThanks ? (
          <button
            type="button"
            className="lottery-prize-view-button"
            onClick={onContinueDraw}
          >
            继续抽奖
          </button>
        ) : (
          <NavLink
            className="lottery-prize-view-button"
            to={prizeAction.link}
            onClick={onClose}
          >
            {prizeAction.text}
          </NavLink>
        )}
        <div className="lottery-prize-modal-note">
          {isThanks
            ? "今日剩余次数可继续参与抽奖"
            : "奖品已自动发放至账户，可在个人中心查看"}
        </div>
      </div>
    </div>
  );
}

export default LotteryPrizeModal;
